// If we don't have a helper setup for it, we just bypass the themeLucid directly
export var themeHelpers = {
    m: { key: 'space', css: 'margin' },
    mb: { key: 'space', css: 'marginBottom' },
    mt: { key: 'space', css: 'marginTop' },
    ml: { key: 'space', css: 'marginLeft' },
    mr: { key: 'space', css: 'marginRight' },
    mx: { key: 'space', css: ['marginLeft', 'marginRight'] },
    my: { key: 'space', css: ['marginTop', 'marginBottom'] },
    p: { key: 'space', css: 'padding' },
    pb: { key: 'space', css: 'paddingBottom' },
    pt: { key: 'space', css: 'paddingTop' },
    pl: { key: 'space', css: 'paddingLeft' },
    pr: { key: 'space', css: 'paddingRight' },
    px: { key: 'space', css: ['paddingLeft', 'paddingRight'] },
    py: { key: 'space', css: ['paddingTop', 'paddingBottom'] },
    color: 'colors',
    bg: { key: 'colors', css: 'background' },
    textScale: 'typography',
    textStyle: 'textStyle',
    fontWeight: 'fontWeights',
    gridGap: 'space',
    gridColumnGap: 'space',
    gridRowGap: 'space',
    border: 'borders',
    borderTop: 'borders',
    borderBottom: 'borders',
    borderLeft: 'borders',
    borderRight: 'borders',
    borderColor: 'colors',
    borderTopColor: 'colors',
    borderBottomColor: 'colors',
    borderLeftColor: 'colors',
    borderRightColor: 'colors',
    borderRadius: 'radii',
    borderTopLeftRadius: 'radii',
    borderTopRightRadius: 'radii',
    borderBottomLeftRadius: 'radii',
    borderBottomRightRadius: 'radii',
    boxShadow: 'shadows',
    textShadow: 'shadows',
    zIndex: 'zIndices',
    top: 'space',
    right: 'space',
    left: 'space',
    bottom: 'space',
    opacity: 'opacities',
    width: 'sizes',
    minWidth: 'sizes',
    maxWidth: 'sizes',
    height: 'sizes',
    minHeight: 'sizes',
    maxHeight: 'sizes',
    transition: 'transitions',
    transform: null
};
//# sourceMappingURL=helpers.js.map